import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { selectItalyFiscalCodesManagement } from '../italyFiscalCodesManagementSelectors'
import { askDelete, openEditModal } from '../italyFiscalCodesManagementSlice'

export interface LocationRowData {
  id: number
  code: string
  name: string
  onEdit: () => void
  onDelete: () => void
}

const useLocationsTable = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { locations, search } = useSelector(selectItalyFiscalCodesManagement)

  const rows: LocationRowData[] = locations.map(location => ({
    id: location.id,
    code: location.code,
    name: location.name,
    onEdit: () => dispatch(openEditModal(location)),
    onDelete: () => dispatch(askDelete(location)),
  }))

  return {
    rows,
    codeLabel: t('italyFiscalCodesManagement:table.code'),
    nameLabel: t('italyFiscalCodesManagement:table.name'),
    actionsLabel: t('italyFiscalCodesManagement:table.actions'),
    editLabel: t('common:edit'),
    deleteLabel: t('common:delete'),
    emptyText: search
      ? t('italyFiscalCodesManagement:table.empty_search', { search })
      : t('italyFiscalCodesManagement:table.empty'),
  }
}

export default useLocationsTable
